var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.8181,
    cy: 15,
    r: 15,
    fill: "#81BC3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.672 17.1576L19.4414 16.3883C19.5616 16.2681 19.7707 16.3522 19.7707 16.5253V20.021C19.7707 20.6581 19.2538 21.175 18.6167 21.175H10.154C9.5169 21.175 9 20.6581 9 20.021V11.5583C9 10.9212 9.5169 10.4043 10.154 10.4043H16.7295C16.9002 10.4043 16.9867 10.611 16.8665 10.7336L16.0972 11.503C16.0611 11.539 16.013 11.5583 15.9601 11.5583H10.154V20.021H18.6167V17.2922C18.6167 17.2418 18.636 17.1937 18.672 17.1576ZM22.437 12.306L16.1236 18.6194L13.9502 18.8598C13.3203 18.9295 12.7842 18.3982 12.8539 17.7635L13.0943 15.5901L19.4077 9.27669C19.9583 8.72613 20.8478 8.72613 21.396 9.27669L22.4346 10.3153C22.9851 10.8659 22.9851 11.7578 22.437 12.306ZM20.0617 13.0489L18.6648 11.652L14.1978 16.1214L14.0223 17.6913L15.5923 17.5158L20.0617 13.0489ZM21.6196 11.1327L20.581 10.0941C20.4824 9.99554 20.3213 9.99554 20.2251 10.0941L19.4822 10.837L20.8791 12.2338L21.622 11.4909C21.7181 11.39 21.7181 11.2313 21.6196 11.1327Z",
    fill: "#F8F9FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e170bbdd62b8c8e1f82620724558bc77.svg";
export { ForwardRef as ReactComponent };